import Api from "../../../gd/api/api"
import {CopyProject_Manager} from "./copy-project-manager"

// const debug = "CopyTemplate_Manager"
const debug = false

export class CopyTemplate_Manager extends CopyProject_Manager {

    get modalTitle():string {
        return this.copyAsTemplate ? 'Save as Template' : 'Duplicate Template'
    }

    async commitCopy(result: any) {
        if (result) this.result = result

        const response =  await Api.Project.copyTemplate({
            templateId  : this.projectToCopy.id,
            name        : this.result.name,
        }).promise()

        if (this.redirectToCopy) {
            gd.navigation.goToProject(response.projectId)
        }

        this.onCopy?.()
        gd.modal.hide()
    }
}